import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import SendIcon from '@mui/icons-material/Send';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';

import { AI_COLORS } from '../aiAnalyticsConstants';

import { REFINE_MODES } from './ChatMessage.service';

const REFINE_PLACEHOLDERS = {
  [REFINE_MODES.QUERY]: 'How should the query be improved? e.g. "only count active patients"',
  [REFINE_MODES.CHART]: 'How should the chart be refined? e.g. "make it a bar chart, color by region"'
};

export default function RefineInputRow({ mode, value, onChange, onSubmit, onCancel, busy }) {
  return (
    <Box sx={{ mt: 1, display: 'flex', alignItems: 'flex-start', gap: 1 }}>
      <TextField
        autoFocus
        fullWidth
        size="small"
        multiline
        maxRows={3}
        placeholder={REFINE_PLACEHOLDERS[mode]}
        value={value}
        onChange={e => onChange(e.target.value)}
        onKeyDown={e => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            onSubmit();
          } else if (e.key === 'Escape') {
            onCancel();
          }
        }}
        disabled={busy}
      />
      <IconButton
        size="small"
        onClick={onSubmit}
        disabled={!value.trim() || busy}
        sx={{
          backgroundColor: AI_COLORS.brand,
          color: AI_COLORS.onBrand,
          '&:hover': { backgroundColor: AI_COLORS.brandDark },
          '&.Mui-disabled': { backgroundColor: AI_COLORS.border }
        }}
      >
        <SendIcon fontSize="small" />
      </IconButton>
      <IconButton size="small" onClick={onCancel} disabled={busy}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}
